export default "__VITE_ASSET__W4RJEXnl__"